import { useMutation, useQueryClient } from "@tanstack/react-query"

import { usePaginatedResource, useResourceItem } from "./useCrudResource"
import {
  getVehicleImporterStaffs,
  getVehicleImporterStaff,
  createVehicleImporterStaff,
  updateVehicleImporterStaff,
  deleteVehicleImporterStaff,
} from "api/vehicleImporterStaffApi"

export const VEHICLE_IMPORTER_STAFF_QUERY_KEY = "vehicle-importer-staff"

const scopedKey = importerId => `${VEHICLE_IMPORTER_STAFF_QUERY_KEY}-${importerId}`

export const useVehicleImporterStaffs = (importerId, params = {}, enabled = true) =>
  usePaginatedResource(
    scopedKey(importerId),
    qs => getVehicleImporterStaffs(importerId, qs),
    params,
    enabled && !!importerId
  )

export const useVehicleImporterStaff = (importerId, id, enabled = true) =>
  useResourceItem(
    scopedKey(importerId),
    qid => getVehicleImporterStaff(importerId, qid),
    id,
    enabled && !!importerId && !!id
  )

export const useCreateVehicleImporterStaff = importerId => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: payload =>
      createVehicleImporterStaff({ importerId, ...payload }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [scopedKey(importerId)] })
      queryClient.invalidateQueries({ queryKey: ["vehicleImporters"] })
    },
  })
}

export const useEditVehicleImporterStaff = importerId => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: payload =>
      updateVehicleImporterStaff({ importerId, ...payload }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [scopedKey(importerId)] })
      queryClient.invalidateQueries({ queryKey: ["vehicleImporters"] })
    },
  })
}

export const useDeleteVehicleImporterStaff = importerId => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: id => deleteVehicleImporterStaff(importerId, id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [scopedKey(importerId)] })
      queryClient.invalidateQueries({ queryKey: ["vehicleImporters"] })
    },
  })
}
